module.exports = __webpack_public_path__ + "static/stpaul-logo-5d3b9a9d7efcdcd23e1126a1608a2f9b.png";